import React from 'react';
import styles from './styles.module.scss';
import LoginForm from '../LoginForm/LoginForm-redux';

const LoginPage = () => {
  return (
    <div className={styles.login}>
      <div className={styles.window}>
        <LoginForm/>
      </div>
    </div>
  );
};

export default LoginPage;
